import axios from "axios";
import { setLoading } from "../Orders/OrderActionCreators";
import Store from "../Store";
import {
  authUnauthorizedMessage,
  setCaptchaCode,
  setResetCaptcha,
  setShowCaptcha,
} from "./LoginActionCreators";
require("dotenv").config();
const BaseUrl =
  // process.env.NODE_ENV === "development"
  // ?
  process.env.REACT_APP_BASE_URL_DEV;
// : process.env.REACT_APP_BASE_URL_PRO;

export const authLessAxios = axios.create({
  baseURL: BaseUrl,
});

authLessAxios.interceptors.request.use((config) => {
  if (!navigator.onLine) {
    const chanel = new BroadcastChannel("isOnline");
    chanel.postMessage({ msg: "notOnline" });
  }

  Store.dispatch(setLoading(true));

  return config;
});

authLessAxios.interceptors.response.use(
  (config) => {
    Store.dispatch(setLoading(false));
    return config;
  },
  (error) => {
    const { resetCaptcha } = Store.getState().loginReducer;

    Store.dispatch(setLoading(false));
    switch (error.response.status) {
      case 400:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(setResetCaptcha(resetCaptcha + 1));
        Store.dispatch(setCaptchaCode(""));
        break;
      case 401:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(setResetCaptcha(resetCaptcha + 1));
        break;
      case 402:
        Store.dispatch(setShowCaptcha(true));
        Store.dispatch(setResetCaptcha(resetCaptcha + 1));
        break;
      case 403:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(setResetCaptcha(resetCaptcha + 1));
        break;
      case 404:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(setResetCaptcha(resetCaptcha + 1));
        break;

      default:
        break;
    }

    return Promise.reject(error);
  }
);
